import { FileIconStyled } from './FileIconStyled';

export const GameIcon = FileIconStyled({ iconOutSize: 100, iconSize: 90 });
